/**
 * Classify auth failures: is the SESSION dead, or was the server just
 * unreachable?
 *
 * Only a server that answers and rejects the session (`invalid_grant`, a 401
 * that survives a refresh) may sign the user out. A network failure, a 5xx or
 * a 429 — Maestro restarting, App Runner answering 502 while the container
 * comes back — says nothing about the session. On 2026-10-26 a ~30 s Maestro
 * restart (OOM) signed every user out because these were treated alike:
 * the refresh token was wiped on a page reload and the 401-recovery path
 * logged out on any refresh failure.
 *
 * Errors carry `code` ("invalid_grant" | "oauth" | "network", from
 * oauthService / apiService) and, for HTTP failures, `status`.
 */
export function isTransientAuthError(err) {
  if (!err || err.code === "invalid_grant") return false;
  if (err.code === "network") return true;
  const status = Number(err.status);
  return status === 429 || status >= 500;
}
